module.exports = __webpack_public_path__ + "static/media/Serif_Socks.3e8e2b09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Serif_Socks.jpg
// module id = 627
// module chunks = 0